import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { ProfileOverview, ProfileUpdateReq } from '@/types/profile'

/** `GET /app/profile/overview`（需 Authorization） */
export function getProfileOverview(): Promise<ApiResponse<ProfileOverview>> {
  return http.get<ApiResponse<ProfileOverview>>('/app/profile/overview').then((r) => r.data)
}

/** `POST /app/profile/update`（需 Authorization）。空串清空字段，不传不修改。 */
export function updateProfile(payload: ProfileUpdateReq): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/profile/update', payload).then((r) => r.data)
}
